export const LOGIN = "/api/auth/login"
export const LOGOUT = "/api/auth/logout"

export const FORGOT_PASSWORD = "/api/auth/reset-request"
export const RESET_PASSWORD = "/api/auth/reset"
export const FETCH_TOKEN = "/api/auth/check-reset-token/:param"

export const REGISTER = "/api/auth/register"
